import axiosClient from "../../../../../../axiosClient"

export default async (packageSlug) => {
    const result = await axiosClient.get(`/request-package/${packageSlug}`)

    return result.data
}
